import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { stringToNumber, isString } from '../../../helpers';

import './VatMessage.scss';

function getVatMessage(props) {
  const {
    shortMessage = false,
    isPriceInclVat = false,
    taxLabelStyle = 'VAT',
  } = props;
  const withVat = isPriceInclVat ? '.incl' : '';
  const isShort = shortMessage && isPriceInclVat ? '.short' : '';
  const vatName = ['VAT', 'Tax'].includes(taxLabelStyle)
    ? `.localised.${taxLabelStyle.toLowerCase()}`
    : '.vat.amount';
  return `site.purchase${withVat}${isShort}${vatName}`;
}

export default function VatMessage(props) {
  const {
    shortMessage = false,
    isPriceInclVat = false,
    taxLabelStyle = 'VAT',
    vatRate = '',
    vat,
    className = '',
    isCarbonOffsetApply,
  } = props;
  const { t } = useTranslation();
  const vatRateAmount = isString(vatRate) ? stringToNumber(vatRate) : vatRate;

  return (
    <div className={`c-vat-message ${className}`}>
      {vatRateAmount > 0 &&
        t(
          getVatMessage({
            shortMessage,
            isPriceInclVat,
            taxLabelStyle,
          }),
          { 0: vatRateAmount, 1: taxLabelStyle },
        )}{' '}
      {vat && <span className="c-vat-message__amount">{vat}</span>}
      {isCarbonOffsetApply && (
        <div className="c-vat-message__carbon">
          {t('site.purchase.select-package.carbon.excludes')}
        </div>
      )}
    </div>
  );
}

VatMessage.propTypes = {
  shortMessage: PropTypes.bool,
  isPriceInclVat: PropTypes.bool,
  isCarbonOffsetApply: PropTypes.bool,
  taxLabelStyle: PropTypes.string,
  className: PropTypes.string,
  vatRate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  vat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
